export default "__VITE_ASSET__249c6d5c__"